<template>
    <v-main>
        <img src="@/assets/images/img-datos-descuento/img-descuentos.jpeg" class="img-left">
        <img src="@/assets/images/img-datos-descuento/img-descuentos0.jpeg" class="img-right">

        <div class="container">

            <v-card class="pa-3 mt-4 card" elevation="0" outlined width="450" height="560">
                <div class="mb-2"> <label class="">Llena tus datos</label></div>
                <div class="mb-3">
                    <v-btn-toggle color="light-blue darken-1" v-model="typeIdentificacion" @change="toggleIdentificacion()"
                        mandatory dense>
                        <v-btn value="CED">
                            <b>CED</b>
                        </v-btn>
                        <v-btn value="RUC">
                            <b>RUC</b>
                        </v-btn>
                        <v-btn value="PAS">
                            <b>PAS</b>
                        </v-btn>
                    </v-btn-toggle>
                </div>
                <v-form ref="form" v-model="valid" lazy-validation validate>
                    <v-text-field width="10%" color="light-blue darken-1" flat dense outlined v-model="identificacion"
                        :rules="identificacionRules" label="Identificación" required></v-text-field>

                    <v-text-field color="light-blue darken-1" flat dense outlined v-model="name" :rules="nameRules"
                        label="Nombre"></v-text-field>

                    <v-text-field color="light-blue darken-1" flat dense outlined v-model="apellido" :rules="apellidoRules"
                        label="Apellido" required></v-text-field>

                    <v-text-field color="light-blue darken-1" flat dense outlined v-model="email" :rules="emailRules"
                        label="Correo" required></v-text-field>

                    <v-text-field color="light-blue darken-1" flat dense outlined v-model="celular" :counter="10"
                        :rules="celularRules" label="Celular" required></v-text-field>

                    <v-switch color="light-blue darken-1" :rules="switchRules" class="mt-0" v-model="switch1" inset
                        required>
                        <template v-slot:label>
                            <div>
                                <template>
                                    <a target="_blank" :href="dominioServer + '/terminoscondiciones'" @click.stop
                                        style="text-decoration: none;">
                                        Acepto los términos, condiciones y políticas de privacidad
                                    </a>
                                </template>
                            </div>
                        </template>
                    </v-switch>
                    <v-btn color="success" class="mt-3" @click="guardar">
                        Guardar
                    </v-btn>
                    <!-- <v-btn color="success" class="mt-3" @click="guardar">
                        Guardar
                    </v-btn> -->
                </v-form>
                <div v-if="showModal">
                    <Modal @click="closeDialog" :title="modalValues.title" :type="modalValues.type"
                        :message="modalValues.message" :show="modalValues.show" :size="modalValues.size"
                        :theme="modalValues.theme" :accion="modalValues.accion" />
                </div>
            </v-card>

            <!-- modal dialog -->

        </div>
    </v-main>
</template>
<script>
import promocionesService from '@/services/promocionesService';
import { ipServer } from '@/services/rutaService';
import Modal from '@/components/dialog/ModalDialog.vue';


export default {
    components: {
        Modal
    },
    data: () => ({
        dominioServer: ipServer,
        switch1: false,
        switchRules: [v => !!v || 'Debe aceptar los terminos y condiciones'],
        valid: true,
        name: '',
        nameRules: [
            v => !!v || 'Nombre es obligatorio',

        ],

        apellido: '',
        apellidoRules: [
            v => !!v || 'Apellido es obligatorio',
        ],
        identificacion: '',
        identificacionRules: [
            v => !!v || 'Identificación es obligatorio',
            v => validarCedula(v) || 'Identificacíon no valida',
        ],
        celular: '',
        celularRules: [
            v => !!v || 'Celular es obligatorio',
            v => /^\d+$/.test(v) || 'Ingrese solo números',
            v => /^\d{1,10}$/.test(v) || 'Cantidad de digitos incorrecto'

        ],
        email: '',
        emailRules: [
            v => !!v || 'Correo es obligatorio',
            v => /.+@.+\..+/.test(v) || 'Correo no valido',
        ],
        checkbox: false,
        typeIdentificacion: '',
        showModal: '',
        modalValues: {
            title: null,
            type: null,
            message: null,
            show: null,
            size: null,
            theme: null,
            accion: null
        },
    }),

    methods: {

        async guardar() {
            try {
                if (this.$refs.form.validate()) {
                    let params = {
                        "identificacion": this.identificacion,
                        "nombre": this.name,
                        "apellido": this.apellido,
                        "telefono": this.celular,
                        "correo": this.email,
                        "tipo": "I"
                    }

                    let response = await promocionesService.registraClienteDesc(params);
                    let resp = response.data
                    //let mensaje = '<p>Felicidades ahora eres acreedor(a) del beneficio del 10% de descuento en tu proxima compra.</p>';
                    // mensaje = mensaje + '<p>Puedes encontar nuentros productos ingresando a nuestra pagina web '
                    //  mensaje = mensaje + ' <a href="https://www.superexito.com.ec/" target="_blank">haciendo click aqui</a></p>'
                    if (resp.codigo == 0) {
                        this.openDialog('Super exito', 1, resp.mensaje, true, '500', 'yellow');
                        this.limpiar()
                    } else {
                        this.openDialog('Super exito', 1, resp.mensaje, true, '500', 'yellow');
                    }
                }
            } catch (error) {
                this.loading = false;
                console.log(error)
            }
        },
        limpiar() {
            /*  this.identificacion = '';
             this.name = '';
             this.apellido = '';
             this.celular = '';
             this.email = '';
             this.switch1 = false; */
            this.$refs.form.resetValidation()
            this.$refs.form.reset()

        },
        validaForm() {
            if (this.celular.length != 10) {
                return false
            }
        },
        toggleIdentificacion() {
            tipoIde = this.typeIdentificacion;
            validarCedula(this.identificacion)
            //this.identificacion = '';
        },
        openDialog(title, type, message, show, size, theme, accion) {
            this.showModal = true;
            this.modalValues = {
                title: title,
                type: type,
                message: message,
                show: show,
                size: size,
                theme: theme,
                accion: accion,
            }
        },
        closeDialog() {
            this.showModal = false
        },
        /*   ambienteProduccion(valor) {
              if (valor) {
                  this.dominioServer = ipServer + '/promociones/terminoscondiciones';
              } else {
                  this.dominioServer = 'http://192.168.8.11:8080/promociones/terminoscondiciones';
              }
          } */
    }, beforeMount() {
        // this.ambienteProduccion(false);



    }
}
let tipoIde = 'CED';
function validarCedula(identificacion) {
    if (identificacion) {
        if (tipoIde == 'CED') {
            let cad = identificacion.trim();
            let total = 0;
            let longitud = cad.length;
            let longcheck = longitud - 1;
            if (cad !== "" && longitud === 10) {
                for (let i = 0; i < longcheck; i++) {
                    if (i % 2 === 0) {
                        let aux = cad.charAt(i) * 2;
                        if (aux > 9) aux -= 9;
                        total += aux;
                    } else {
                        total += parseInt(cad.charAt(i));
                    }
                }
                total = total % 10 ? 10 - total % 10 : 0;
                if (cad.charAt(longitud - 1) == total) {
                    return true;
                } else {
                    return false;
                }
            }
        } if (tipoIde == 'RUC') { // Verificar la longitud del RUC (debe tener 13 dígitos)
            if (identificacion.length !== 13) {
                return false;
            }

            // Verificar que los primeros dos dígitos sean dígitos válidos para la provincia
            var provincia = parseInt(identificacion.substr(0, 2), 10);
            if (provincia < 1 || provincia > 24) {
                return false;
            }

            // Verificar el tercer dígito (debe ser 9 para sociedades privadas y 6 para personas naturales)
            /*  var tercerDigito = parseInt(identificacion[2], 10);
              if (tercerDigito !== 9 && tercerDigito !== 6) {
                  return false;
              }*/

            // Verificar el último dígito (dígito verificador)
            /*   var verificador = parseInt(identificacion[12], 10);
              var coeficientes = [3, 2, 7, 6, 5, 4, 3, 2];
              var suma = 0;
  
              for (var i = 0; i < 8; i++) {
                  suma += parseInt(identificacion[i], 10) * coeficientes[i];
              }
   */
            //  var modulo = suma % 11;
            // var resultado = modulo === 0 ? 0 : 11 - modulo;

            /*if (resultado !== verificador) {
                return false;
            }*/

            return true;
        } if (tipoIde == 'PAS') {
            if (identificacion.length < 6 || identificacion.length > 9) {
                return false;
            }

            // Verificar que el pasaporte contenga solo letras y números
            var regex = /^[a-zA-Z0-9]+$/;
            if (!regex.test(identificacion)) {
                return false;
            }

            return true;
        }
    }



}
</script>
<style scoped>
@import '@/assets/styles/styles-descuento-datos/style-datos.css';
</style>